import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { buildPactoRebatesParamsQuery,
    formatPactoRebatesParamsResponse
} from "../../utils/pacto-rebates-params-utils";

export function usePactoRebatesParams() {
	const [pactoRebatesParams, setPactoRebatesParams] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchPactoRebatesParams(fields = {}) {
        try {
            setLoading(true);
            setError(null);
            setPactoRebatesParams([]);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const queryString = buildPactoRebatesParamsQuery(fields);

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/configuracoes${queryString}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(response, "Erro ao buscar parâmetros Pacto Rebates.");
            }

            const data = await response.json();
            const pactoRebatesParamsData = Array.isArray(data.resultado)
				? data.resultado[0]
				: data.resultado || data;

            const formattedPactoRebatesParams = Array.isArray(pactoRebatesParamsData)
                ? pactoRebatesParamsData.map(formatPactoRebatesParamsResponse)
                : pactoRebatesParamsData
                    ? [formatPactoRebatesParamsResponse(pactoRebatesParamsData)]
                    : [];

            setPactoRebatesParams(formattedPactoRebatesParams);

            return {
                ok: true,
                empty: formattedPactoRebatesParams.length === 0,
                pactoRebatesParams: formattedPactoRebatesParams
            };
        } catch (requestError) {
            setPactoRebatesParams([]);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

	return {
		pactoRebatesParams,
		loading,
		error,
		refetch: fetchPactoRebatesParams
	};
}